import styled from '@emotion/styled'
import { calcRem, breakpoint, breakpointMax } from 'component-library/__styling/style-functions'
import { conditionalStyles } from 'component-library/__styling/conditional-styles'

export const StyledSocialLinks = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginTop: calcRem(9),

    '& > a + a': {
        marginLeft: calcRem(8),
    },

    ...conditionalStyles(theme.kind === 'sevennews', {
        marginTop: 0,
        '& > a': {
            width: calcRem(39),
            height: calcRem(39),
        },

        [breakpoint('sm')]: {
            '& > a': {
                width: calcRem(28),
                height: calcRem(28),
            },
        },
        [breakpointMax('xxs')]: {
            justifyContent: 'space-between',
        },
    }),
}))
